module.exports = __webpack_public_path__ + "img/_india.4494fe1d.png";